import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * How It Works — Desktop Vertical Sticky Scroll & Mobile Horizontal Swipe Engine
 * Provides precise desktop scroll runway (no huge empty gap) and converts mobile layout
 * into an interactive horizontal scroll-snap track.
 */
export function initHowItWorks() {
  const stepItems = document.querySelectorAll('.how-step-item');
  const panels = document.querySelectorAll('.how-panel');
  const stepsColumn = document.querySelector('.how-steps-column');

  if (!stepItems.length || !panels.length) return;

  let activeIndex = -1;

  function activateStep(index) {
    if (index === activeIndex || index < 0 || index >= stepItems.length) return;
    activeIndex = index;

    // 1. Update Left Step Cards Accent State
    stepItems.forEach((step, i) => {
      if (i === index) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });

    // 2. Crossfade Right Window Panels
    panels.forEach((panel, i) => {
      if (i === index) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });
  }

  // 3. Click Navigation (Desktop Vertical Scroll / Mobile Horizontal Snap)
  stepItems.forEach((step, index) => {
    step.addEventListener('click', () => {
      activateStep(index);
      
      if (window.innerWidth >= 1024) {
        const rect = step.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetY = rect.top + scrollTop - 120;
        
        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      } else {
        step.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    });
  });

  // 4. Desktop Vertical ScrollTrigger vs Mobile Horizontal Intersection Observer
  ScrollTrigger.matchMedia({
    // DESKTOP (≥ 1024px): Precise Vertical Sticky Scroll
    "(min-width: 1024px)": function() {
      stepItems.forEach((step, index) => {
        const isLast = index === stepItems.length - 1;

        ScrollTrigger.create({
          trigger: step,
          start: 'top 220px',
          end: isLast ? 'bottom 100px' : 'bottom 220px',
          onEnter: () => activateStep(index),
          onEnterBack: () => activateStep(index)
        });
      });
    },

    // MOBILE (< 1024px): Horizontal Swipe Intersection Observer
    "(max-width: 1023px)": function() {
      if (!stepsColumn) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Array.from(stepItems).indexOf(entry.target);
            if (index !== -1) {
              activateStep(index);
            }
          }
        });
      }, {
        root: stepsColumn,
        threshold: 0.6
      });

      stepItems.forEach(step => observer.observe(step));
    }
  });

  // Activate Step 01 initially
  activateStep(0);
}
